import {
  Box,
  Circle,
  Button,
  DatePill,
  EmptyState,
  Flex,
  IconButton,
  Loader,
  Panel,
  Table,
} from "@coaching-culture/ui";
import { useGoalTerminology } from "auth/OrgProvider";
import { ScrollableContainer } from "components/ScrollableContainer";
import { sortBy } from "lodash";
import { GoalProgressDisplay } from "pages/Solutions/Performance/GoalProgressDisplay";
import { useMyGoals } from "queries/performance";
import { FaEye, FaMedal, FaPlusCircle, FaStar } from "react-icons/fa";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { useTheme } from "styled-components";
import { WidgetPanelHeader } from "./WidgetPanelHeader";

export function GoalWidget() {
  const terms = useGoalTerminology();
  const { data: goals, isFetched } = useMyGoals();
  const history = useHistory();
  const theme = useTheme();

  const ReviewGoal = (id: string) => {
    history.push(`/solutions/performance/goals/${id}/review`);
  };

  if (!isFetched) {
    return <Loader />;
  }

  const sortedGoals = sortBy(
    goals.filter((x) => x.completedOn == null),
    (x) => [
      !x.isStarred,
      x.completedOn == null ? x.deadline : Number.MAX_VALUE,
    ],
  );

  return (
    <Panel>
      <WidgetPanelHeader title={terms.goal.asPluralTitle()}>
        <Button icon={FaPlusCircle} to="/solutions/performance/goals/create">
          Create {terms.goal.asBody()}
        </Button>
      </WidgetPanelHeader>
      {goals.length === 0 ? (
        <EmptyState compact icon={FaMedal}>
          No active {terms.goal.asPluralBody()} yet.
        </EmptyState>
      ) : (
        <Box>
          <ScrollableContainer maxHeight={310}>
            <Table>
              <thead
                style={{
                  top: 0,
                  background: theme.colors.surface,
                  position: "sticky",
                  marginBottom: "20px",
                  zIndex: 3,
                }}
              >
                <th>{terms.goal.asTitle()}</th>
                <th>Last review</th>
                <th>Status</th>
                <th />
              </thead>

              <tbody>
                {sortedGoals.map((x) => (
                  <tr>
                    <td>
                      <Flex alignItems={"center"}>
                        {x.isStarred && (
                          <Circle
                            icon={FaStar}
                            color="star"
                            size="small"
                            mr={1}
                          />
                        )}
                        {x.purpose}
                      </Flex>
                    </td>
                    <td>
                      <DatePill value={x.updatedOn} />
                    </td>
                    <td>
                      {" "}
                      <Link
                        title={`Review ${terms.goal.asTitle()}`}
                        to={`/solutions/performance/goals/${x.id}/review`}
                      >
                        <GoalProgressDisplay
                          value={x.completedOn != null ? "achieved" : x.status}
                        />
                      </Link>
                    </td>
                    <td>
                      <Flex alignItems="center" justifyContent={"flex-end"}>
                        <IconButton
                          color="primary"
                          icon={FaEye}
                          onClick={() => ReviewGoal(x.id)}
                          mr={2}
                        />
                      </Flex>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </ScrollableContainer>
        </Box>
      )}
    </Panel>
  );
}
